export function hashSlide() {
	const settings = { behavior: "smooth", block: "start", inline: "nearest" };
	const hashParameter = getHashParam();
	const slideEls = document.querySelectorAll("[data-slide-to]");

	function getHashParam() {
		const hash = window.location.hash;
		return hash.slice(1);
	}

	if (hashParameter !== "") {
		const element = document.getElementById(hashParameter);
		element.scrollIntoView(settings);
	}

	slideEls.forEach((el) => {
		el.addEventListener("click", function(e) {
			const url = new URL(el.href);
			const hash = url.hash.slice(1);

			const toScrollEl = document.getElementById(hash);
			if (toScrollEl) {
				const elementPosition = toScrollEl.getBoundingClientRect().top;
				const offsetPosition = elementPosition - 150; // Adjusting to 50px above the element

				window.scrollTo({
					top: offsetPosition,
					behavior: "smooth"
				});

				history.pushState(null, null, '#' + hash);
			}
		})
	});
}
